import { useNavigate } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { TrainingsBudgetWizard } from 'modules/finance/components/TrainingsBudgetWizard'
import { useBudgetsPage } from 'modules/finance/hooks/useBudgets'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const NewBudget = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { legalEntities, loading } = useBudgetsPage(companyId)

  const handleClose = () => {
    navigate(navigation.trainings.budgets.list.fullPath())
  }

  const handleSuccess = (budgetId: string) => {
    app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully') })
    navigate(navigation.trainings.budgets.detail.fullPath({ budgetId }))
  }

  const handleError = () => {
    app.setFlash({ type: 'wrong', message: i18n.t('errors.generic_error') })
  }

  return (
    <ResponsivePage.Body loading={loading} error={undefined}>
      {legalEntities.length > 0 && (
        <TrainingsBudgetWizard
          legalEntities={legalEntities}
          onSuccess={handleSuccess}
          onError={handleError}
          onClose={handleClose}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default NewBudget
